import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["height"]


export default /*#__PURE__*/_defineComponent({
  __name: 'IconCaret',
  props: {
    className: {},
    classFill: {},
    size: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(_ctx.className),
    xmlns: "http://www.w3.org/2000/svg",
    width: "12.025",
    height: _ctx.size || 18,
    viewBox: "0 0 12.025 6.012"
  }, [
    _createElementVNode("path", {
      id: "Icon_ionic-md-arrow-dropdown",
      class: _normalizeClass(`${_ctx.classFill} svg-fill`),
      "data-name": "Icon ionic-md-arrow-dropdown",
      d: "M9,13.5l6.013,6.012L21.025,13.5Z",
      transform: "translate(-9 -13.5)",
      fill: "#adb2b8"
    }, null, 2)
  ], 10, _hoisted_1))
}
}

})